import { BlipTags } from 'blip-toolkit';
import { v4 as uuid } from 'uuid';
import './builderNodeTags.scss';
const BLIP_TAGS_PREFIX = 'blip-tags';
class BuilderNodeTagsController {
    static $inject = ['$element'];
    constructor($element) {
        'ngInject';
        this.$element = $element;
        this.blipTagsId = `${BLIP_TAGS_PREFIX}-${uuid()}`;
        this.blipTagsInstance = new BlipTags({
            canAddOptions: false,
            toggleTagsMode: true,
            canRemoveTags: false,
            canChangeBackground: false,
            mode: 'compact',
        });
        const tagsElement = this.blipTagsInstance.render({});
        this.$element[0].appendChild(tagsElement);
    }
    //
    $onChanges() {
        this.blipTagsInstance.render({
            tags: this.tags || [],
        });
    }
}
BuilderNodeTagsController.$inject = ['$element'];
export const BuilderNodeTagsComponent = {
    template: '<div id="{{$ctrl.blipTagsId}} class="blip-tags"></div>',
    controller: BuilderNodeTagsController,
    controllerAs: '$ctrl',
    bindings: { tags: '<?' },
};
